import "./Documents.scss";
import {
  DocumentsIcon,
  SearchIcon,
  ExternalLinkIcon,
  FilterIcon,
  FileTextIcon,
} from "../../../../../shared/cockpit/components/icons/Icon";
import { LuUpload } from "react-icons/lu";

interface DocumentEntry {
  id: string;
  name: string;
  type: string;
  reference: string;
  refDetails: string;
  status: "AUSSTEHEND" | "GEPRÜFT" | "FREIGEGEBEN";
  uploadedBy: string;
  date: string;
}

const documentsData: DocumentEntry[] = [
  {
    id: "D1",
    name: "Netzanschlussbegehren_FitX_Berlin.pdf",
    type: "PROTOCOL",
    reference: "Retrofit Ladeinfrastruktur & PV",
    refDetails: "PROJECT: PRJ1",
    status: "AUSSTEHEND",
    uploadedBy: "A. Bauer",
    date: "15.03.2026",
  },
  {
    id: "D2",
    name: "Installationsvertrag_ElektroSchulz.pdf",
    type: "CONTRACT",
    reference: "Schnelllader-Installation",
    refDetails: "PROJECT: PRJ2",
    status: "GEPRÜFT",
    uploadedBy: "M. Schmidt",
    date: "28.02.2026",
  },
  {
    id: "D3",
    name: "Inbetriebnahmeprotokoll_Hafenquartier.pdf",
    type: "PROTOCOL",
    reference: "Mieterstrom & Wärmepumpe",
    refDetails: "PROJECT: PRJ3",
    status: "FREIGEGEBEN",
    uploadedBy: "L. Weber",
    date: "05.01.2026",
  },
  {
    id: "D4",
    name: "Dachstatik_Gutachten_FitX.pdf",
    type: "PLAN",
    reference: "FitX Berlin-Alexanderplatz",
    refDetails: "PROPERTY: P1",
    status: "AUSSTEHEND",
    uploadedBy: "Statik Büro Nord",
    date: "16.03.2026",
  },
  {
    id: "D5",
    name: "Wartungsvertrag_Alpitronic.pdf",
    type: "CONTRACT",
    reference: "A3",
    refDetails: "SERVICE: A3",
    status: "FREIGEGEBEN",
    uploadedBy: "SolarMolar Backoffice",
    date: "10.01.2026",
  },
];

function Documents() {
  return (
    <div className="documents-view">
      <header className="documents-view__header">
        <div className="documents-view__header__content">
          <div className="documents-view__header__title--container">
            <div className="documents-view__header__icon-wrapper">
              <DocumentsIcon />
            </div>
            <h1 className="documents-view__header__title">
              Dokumente & Freigaben
            </h1>
          </div>
          <p className="documents-view__header__subtitle">
            Zentrale Ablage und Freigabe-Workflows für Protokolle, Verträge und
            Pläne.
          </p>
        </div>
        <button className="documents-view__header__upload-btn">
          <LuUpload /> Dokument hochladen
        </button>
      </header>

      <div className="documents-view__content">
        <div className="documents-view__toolbar">
          <div className="search-bar">
            <SearchIcon />
            <input
              type="text"
              placeholder="Dateiname oder Uploader suchen..."
            />
          </div>
          <div className="filter-group">
            <FilterIcon className="filter-icon" />
            <select className="status-select">
              <option>Alle Status</option>
              <option>Ausstehend</option>
              <option>Geprüft</option>
              <option>Freigegeben</option>
            </select>
          </div>
        </div>

        <div className="documents-table">
          <div className="documents-table__header">
            <div className="documents-table__col">DOKUMENT</div>
            <div className="documents-table__col">BEZUG</div>
            <div className="documents-table__col">STATUS</div>
            <div className="documents-table__col">HOCHGELADEN VON</div>
            <div className="documents-table__col">DATUM</div>
            <div className="documents-table__col text-right">AKTION</div>
          </div>

          <div className="documents-table__body">
            {documentsData.map((doc) => (
              <div key={doc.id} className="documents-table__row">
                <div className="documents-table__col">
                  <div className="doc-info">
                    <div className="doc-info__main">
                      <FileTextIcon className="doc-info__icon" />
                      <span className="doc-info__name">{doc.name}</span>
                    </div>
                    <span className="doc-info__type">{doc.type}</span>
                  </div>
                </div>

                <div className="documents-table__col">
                  <div className="ref-info">
                    <span className="ref-info__name">{doc.reference}</span>
                    <span className="ref-info__details">{doc.refDetails}</span>
                  </div>
                </div>

                <div className="documents-table__col">
                  <span
                    className={`status-badge status-badge--${doc.status.toLowerCase()}`}
                  >
                    {doc.status.charAt(0) + doc.status.slice(1).toLowerCase()}
                  </span>
                </div>

                <div className="documents-table__col">
                  <span className="uploader-info">{doc.uploadedBy}</span>
                </div>

                <div className="documents-table__col">
                  <span className="date-info">{doc.date}</span>
                </div>

                <div className="documents-table__col text-right">
                  <button className="action-btn">
                    <ExternalLinkIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Documents;
